var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-tooltip', { attrs: { "placement": _vm.placement, "width": "200", "trigger": "hover", "disabled": _vm.disabledToolTip, "title": _vm.extractTextFromHTML(_vm.content) } }, [_c('span', { attrs: { "slot": "content" }, domProps: { "innerHTML": _vm._s(_vm.content) }, slot: "content" }), _vm._v(" "), _c('span', { staticClass: "show-content-text", class: {
      'is-disabled': _vm.disabled,
      'is-activable': _vm.activable
    }, style: {
      maxWidth: _vm.width + 'px'
    }, domProps: { "innerHTML": _vm._s(_vm.highlightContent) }, on: { "mouseenter": function mouseenter($event) {
        return _vm.hover($event);
      } } })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };